// Mock data pentru MC MaxClean OG

export const companyInfo = {
  name: "MC MaxClean OG",
  tagline: "Professionelle Reinigungs- und Hausbetreuungsdienste in Graz",
  manager: "Ing. Lic. Viorel Tanase",
  phone: "+43 676 969 8442",
  email: "mc.maxclean.og@gmail.com",
  address: {
    street: "Wasserwerkstraße 21/3",
    city: "8073 Feldkirchen bei Graz",
    country: "Österreich"
  },
  coordinates: {
    lat: 47.0579,
    lng: 15.4277
  }
};

export const services = [
  {
    id: 1,
    icon: "home",
    title: "Hausbetreuung",
    description: "Umfassende Betreuung und Pflege Ihrer Immobilie das ganze Jahr über.",
    image: "https://images.unsplash.com/photo-1485310818226-f01c4269687f?w=800&q=80",
    features: [
      "Allgemeine Reinigung und Wartung",
      "Treppenhaus- und Gemeinschaftsflächenreinigung",
      "Kontrolle und Wartung der Haustechnik",
      "Kleinreparaturen und Instandhaltung"
    ],
    subServices: [
      {
        id: "winter",
        icon: "snowflake",
        title: "Winterdienst",
        description: "Zuverlässige Schneeräumung und Streudienste für Ihre Sicherheit im Winter.",
        image: "https://images.unsplash.com/photo-1517430784299-86c141b421df?w=800&q=80",
        features: [
          "Professionelle Schneeräumung",
          "Streudienst bei Glatteis",
          "24/7 Winternotdienst",
          "Dach- und Gehwegräumung"
        ]
      },
      {
        id: "green",
        icon: "trees",
        title: "Grünflächenpflege",
        description: "Professionelle Pflege Ihrer Grünflächen und Außenanlagen.",
        image: "https://images.unsplash.com/photo-1734079692079-172d8243ebd3?w=800&q=80",
        features: [
          "Rasenmähen und -pflege",
          "Heckenschnitt und Formschnitt",
          "Unkrautbekämpfung",
          "Bepflanzung und Gartenpflege"
        ]
      }
    ]
  },
  {
    id: 2,
    icon: "truck",
    title: "Schneeräumung, Betreuung und Reinigung von Verkehrsflächen",
    description: "Professionelle Sommer- und Winterdienste für Verkehrsflächen und öffentliche Bereiche.",
    image: "https://images.unsplash.com/photo-1629818571630-5523061def62?w=800&q=80",
    features: [
      "Schneeräumung von Verkehrsflächen",
      "Streudienst und Glättebekämpfung",
      "Sommerreinigung und Pflege",
      "Betreuung öffentlicher Flächen"
    ]
  },
  {
    id: 3,
    icon: "sprout",
    title: "Durchführung einfacher Gartenarbeiten",
    description: "Rasen mähen, Bewässern der Grünflächen, Jäten, Mulchen, Einsammeln von Obst.",
    image: "https://images.unsplash.com/photo-1734079692160-fcbe4be6ab96?w=800&q=80",
    features: [
      "Rasen mähen und Rasenpflege",
      "Bewässern der Grünflächen",
      "Jäten und Unkrautentfernung",
      "Mulchen und Bodenpflege",
      "Einsammeln von Obst"
    ]
  },
  {
    id: 4,
    icon: "trash-2",
    title: "Entrümpelung",
    description: "Professionelle Entrümpelung und Entsorgung für Haushalte und Gewerbe.",
    image: "https://images.unsplash.com/photo-1690211506506-57486e819dda?w=800&q=80",
    features: [
      "Wohnungsauflösungen und Haushaltsauflösungen",
      "Kellerentrümpelung und Dachbodenräumung",
      "Gewerbeentrümpelung und Büroauflösung",
      "Sperrmüllabholung und fachgerechte Entsorgung"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Franz Müller",
    role: "Hausverwaltung Graz",
    text: "Herr Tanase kenne ich bereits seit Jahren aus seiner früheren Tätigkeit. Mit MC MaxClean OG hat er nun sein eigenes Unternehmen gegründet – die gewohnte Qualität und Zuverlässigkeit sind geblieben!",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Schmidt",
    role: "Privatkundin",
    text: "Ein frisches Unternehmen mit echter Expertise! Die Grünflächenpflege wird mit viel Sorgfalt durchgeführt. Man merkt die langjährige Erfahrung.",
    rating: 5
  },
  {
    id: 3,
    name: "Thomas Weber",
    role: "Gewerbekunde",
    text: "Endlich ein Partner, der sich Zeit nimmt und individuell berät. Die Kombination aus Erfahrung und persönlichem Service überzeugt mich.",
    rating: 5
  }
];

export const whyChooseUs = [
  {
    icon: "award",
    title: "Bewährte Expertise",
    description: "Langjährige Branchenerfahrung trifft auf frische Perspektiven"
  },
  {
    icon: "shield-check",
    title: "Zuverlässigkeit",
    description: "Pünktlich, gewissenhaft und vertrauenswürdig"
  },
  {
    icon: "users",
    title: "Persönlicher Service",
    description: "Direkter Kontakt und individuelle Betreuung"
  },
  {
    icon: "leaf",
    title: "Umweltbewusst",
    description: "Nachhaltige und ökologische Arbeitsweise"
  },
  {
    icon: "clock",
    title: "Flexibilität",
    description: "Maßgeschneiderte Lösungen für Ihre Bedürfnisse"
  },
  {
    icon: "euro",
    title: "Faire Preise",
    description: "Transparente Kalkulation und wettbewerbsfähige Konditionen"
  }
];
